var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Study",
    transform: "translate(-102.000000, -11763.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(102.000000, 11763.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-3",
    fill: "#FFF7EA",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-laptop-computer-9MRX7CN8LS-Copy",
    transform: "translate(16.000000, 19.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54464454,4.5 L4.54464454,26.685 L0.0876498689,42.13125 C-0.10846021,42.8099989 0.0286008394,43.5405158 0.457833833,44.1042805 C0.887066827,44.6680452 1.55870004,44.9996864 2.27182727,45 L47.7281727,45 C48.4413,44.9996864 49.1129332,44.6680452 49.5421662,44.1042805 C49.9713992,43.5405158 50.1084602,42.8099989 49.9123501,42.13125 L45.4553555,26.685 L45.4553555,4.5 C45.4553555,2.01471863 43.4202056,0 40.9097209,0 L9.09027909,0 C6.57979445,0 4.54464454,2.01471863 4.54464454,4.5 Z M5.28558297,40.5 L8.53116604,29.25 L41.468834,29.25 L44.714417,40.5 L5.28558297,40.5 Z M40.9097209,24.75 L9.09027909,24.75 L9.09027909,4.5 L40.9097209,4.5 L40.9097209,24.75 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.4f2be1013a36d85b968081f2b02717fb.svg";
export { ForwardRef as ReactComponent };